'use client';

import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import Image from 'next/image';
import { Branch } from '@medprev-web-app/api-graphql-client';

import instagramImg from '@/app/(main)/(pages)/_components/branches-section/assets/instagram.png';
import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface BranchSocialNetworkProps {
  branch: Branch;
}

export const BranchSocialNetwork = ({ branch }: BranchSocialNetworkProps) => {
  const analytics = getAnalyticsPlugin();

  function socialNetworkAnalyticsHandle(network: 'facebook' | 'instagram') {
    analytics.track(AnalyticsEnum.CLICK_SOCIAL_MEDIA_BRANCH, {
      rede_social: network,
    });
  }

  return (
    <>
      {(branch.socialMedia?.facebook || branch.socialMedia?.instagram) && (
        <>
          <hr className="bg-gray-300 my-3" />
          <div className="flex flex-col gap-3">
            <Typography
              variant={TypographyVariant.MEDIUM_SUBTITLE}
              className="font-semibold"
            >
              Siga nossas redes sociais
            </Typography>
            {branch.socialMedia?.facebook && (
              <div data-testid={DataTestIdEnum.BRANCH_CONTACT_SOCIAL_MEDIA_FACEBOOK}>
                <Link prefetch={false} href={branch.socialMedia?.facebook} target="_blank" rel="noopener noreferrer">
                  <Button
                    startIcon={faFacebook}
                    variant="outline"
                    startIconClassName="text-blue-facebook"
                    className="bg-white font-semibold justify-start hover:underline h-12 border-gray-300 overflow-hidden"
                    onClick={() => socialNetworkAnalyticsHandle('facebook')}
                  >
                    <Typography
                      variant={TypographyVariant.BODY_TEXT}
                      className="truncate text-green-500"
                    >
                      {branch.socialMedia?.facebookHandle}
                    </Typography>
                  </Button>
                </Link>
              </div>
            )}
            {branch.socialMedia?.instagram && (
              <div data-testid={DataTestIdEnum.BRANCH_CONTACT_SOCIAL_MEDIA_INSTAGRAM}>
                <Link prefetch={false} href={branch.socialMedia?.instagram} target="_blank" rel="noopener noreferrer">
                  <Button
                    variant="outline"
                    className="bg-white font-semibold justify-start hover:underline h-12 border-gray-300 overflow-hidden"
                    onClick={() => socialNetworkAnalyticsHandle('instagram')}
                  >
                    <Image
                      src={instagramImg}
                      alt="instagram"
                      width={24}
                      height={24}
                      className="w-4 h-4 flex-shrink-0"
                    />
                    <Typography
                      variant={TypographyVariant.BODY_TEXT}
                      className="truncate text-green-500"
                    >
                      @
                      {branch.socialMedia?.instagramHandle}
                    </Typography>
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};
